import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { getHeaderCopy } from './helpers';

import { BalloonTrio, CloudDark, CloudLight, CloudWhite, BalloonsMobile } from './ChecklistHeaderSVGs';

import './ChecklistHeader.less';

const ChecklistHeader = ({ daysTillWedding, className, firstName, partnerFirstName, isFirstTimeChecklistUser }) => {
  const [headerCopy, setHeaderCopy] = useState('');

  useEffect(() => {
    setHeaderCopy(getHeaderCopy({ daysTillWedding, isFirstTimeChecklistUser, firstName, partnerFirstName }));
  }, [daysTillWedding]);


  return (
    <div className={cx('checklist__header-container', className)}>
      <div className="checklist__header--content">
        {Boolean(daysTillWedding) && daysTillWedding >= 0 && (
          <span className="checklist__header--subTitle">
            {daysTillWedding} <span className="checklist__countdown--underline">{daysTillWedding === 1 ? 'day' : 'days'} to go!</span>
          </span>
        )}
        <h1 className="checklist__header--title">{headerCopy}</h1>
      </div>
      <BalloonTrio className="hidden-xs" />
      <BalloonsMobile className="hidden-sm hidden-md hidden-lg" />
      <CloudLight />
      <CloudWhite />
      <CloudDark />
    </div>
  );
};

ChecklistHeader.propTypes = {
  daysTillWedding: PropTypes.number,
  className: PropTypes.string,
};

ChecklistHeader.defaultProps = {
  className: '',
};

export default ChecklistHeader;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistHeader/ChecklistHeader.jsx